// third-party
import { FormattedMessage } from 'react-intl';
import ArticleIcon from '@mui/icons-material/Article';
// assets
import UpdateIcon from '@mui/icons-material/Update';

// constant
const icons = {
    ArticleIcon,
    UpdateIcon
};

// ==============================|| UI FORMS MENU ITEMS ||============================== //

const forms = {
    id: 'forms',
    title: 'Forms',
    type: 'group',
    children: [
        {
            id: 'wages',
            title: 'Wage Tax Forms',
            type: 'collapse',
            icon: icons.ArticleIcon,
            color: '#ab1414',
            children: [
                {
                    id: 'w2federal',
                    title: 'W2 Federal',
                    type: 'item',
                    url: '/w2/federal',
                    breadcrumbs: false
                },
                {
                    id: 'w2state',
                    title: 'W2 State',
                    type: 'item',
                    url: '/w2/state',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: '1099',
            title: '1099 Forms',
            type: 'collapse',
            icon: icons.ArticleIcon,
            color: '#e17a11',
            children: [
                {
                    id: '1099nec',
                    title: '1099 NEC',
                    type: 'item',
                    url: '/1099/nec',
                    breadcrumbs: false
                },
                {
                    id: '1099misc',
                    title: '1099 MISC',
                    type: 'item',
                    url: '/1099/misc',
                    breadcrumbs: false
                },
                {
                    id: '1099int',
                    title: '1099 INT',
                    type: 'item',
                    url: '/1099/int',
                    breadcrumbs: false
                },
                {
                    id: '1099div',
                    title: '1099 DIV',
                    type: 'item',
                    url: '/1099/div',
                    breadcrumbs: false
                },
                {
                    id: '1099r',
                    title: '1099 R',
                    type: 'item',
                    url: '/1099/r',
                    breadcrumbs: false
                },
                {
                    id: '1099s',
                    title: '1099 S',
                    type: 'item',
                    url: '/1099/s',
                    breadcrumbs: false
                },
                {
                    id: '1099b',
                    title: '1099 B',
                    type: 'item',
                    url: '/1099/b',
                    breadcrumbs: false
                },
                {
                    id: '1099k',
                    title: '1099 K',
                    type: 'item',
                    url: '/1099/k',
                    breadcrumbs: false
                },
                {
                    id: '1099c',
                    title: '1099 C',
                    type: 'item',
                    url: '/1099/c',
                    breadcrumbs: false
                },
                {
                    id: '1099g',
                    title: '1099 G',
                    type: 'item',
                    url: '/1099/g',
                    breadcrumbs: false
                },
                {
                    id: '1099k',
                    title: '1099 K',
                    type: 'item',
                    url: '/1099/k',
                    breadcrumbs: false
                },
                {
                    id: '1099patr',
                    title: '1099 PATR',
                    type: 'item',
                    url: '/1099/patr',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'aca',
            title: 'ACA Forms',
            type: 'collapse',
            icon: icons.ArticleIcon,
            color: '#2d9305',
            children: [
                {
                    id: '1095b',
                    title: '1095 B',
                    type: 'item',
                    url: '/aca/1095b',
                    breadcrumbs: false
                },
                {
                    id: '1095c',
                    title: '1095 C',
                    type: 'item',
                    url: '/aca/1095c',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'payroll',
            title: 'Payroll Forms',
            type: 'collapse',
            icon: icons.ArticleIcon,
            color: '#ecb602',
            children: [
                {
                    id: '940',
                    title: 'Form 940',
                    type: 'item',
                    url: '/payroll/940',
                    breadcrumbs: false
                },
                {
                    id: '941',
                    title: 'Form 941',
                    type: 'item',
                    url: '/payroll/941',
                    breadcrumbs: false
                },
                {
                    id: '944',
                    title: 'Form 944',
                    type: 'item',
                    url: '/payroll/944',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'corrections',
            title: 'File Corrections',
            type: 'item',
            url: '/corrections',
            icon: icons.UpdateIcon,
            color: '#ab1414',
            breadcrumbs: false
        }
    ]
};

export default forms;
